<template>
  <div>
    <div
      class="p-4 rounded-lg"
      :class="{ 'border-warning-200 border-4': isAuthor, border: !isAuthor }"
    >
      <div class="flex items-center">
        <div
          class="flex items-center justify-center flex-shrink-0 w-10 h-10 text-xl leading-none rounded-full bg-warning-100 text-primary-500 dark:text-primary-400"
        >
          😎
        </div>
        <div class="flex-grow flex-shrink overflow-hidden ms-2">
          <p class="overflow-hidden text-sm whitespace-nowrap text-ellipsis">
            {{ data.customer?.name || "User" }}
          </p>
          <FormRating :value="data.rating" readonly size="sm" />
        </div>

        <div class="self-start flex-shrink-0 text-xs text-end ms-2">
          <DateRelative
            class="text-gray-500 whitespace-nowrap"
            :value="data.createdAt"
          />
          <p
            v-if="data.status == 'unpublished'"
            class="text-warning-500"
            title="Your review is submitted for approval. It will be live soon."
          >
            {{ $t("pending_approval") }}
          </p>
        </div>
      </div>

      <!-- prettier-ignore -->
      <p class="mt-4 text-sm whitespace-pre-line">{{ data.review }}</p>

      <div class="flex items-center mt-4">
        <VyButton
          v-if="isAuthor"
          size="sm"
          color="primary"
          shape="rounded"
          theme="muted"
          :label="$t('edit_review')"
          @click="$nuxt.callHook('modal-open', 'modal-review', data.id)"
        />
      </div>

      <!-- prettier-ignore -->
      <p v-if="data.adminReply" class="p-4 mt-6 text-sm whitespace-pre-line bg-gray-100 rounded-md">{{ data.adminReply
      }}</p>
    </div>

    <ModalReview v-if="isAuthor" @refresh="$emit('refresh')" />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isAuthor: Boolean,
  },
  emits: ["refresh"],
};
</script>
